const DEFAULT_SERVER_PRO = "https://www.wiki-menu.app"; 
const DEFAULT_SERVER_DEV = "https://www.wiki-menu.app"; //"http://192.168.1.133:1337"; 


 function getServer() {
  let appEnv = getMeta("env");
  if(!appEnv){
    appEnv=process.env.NODE_ENV;
  }

  let server = getMeta("server");
  if(!server){
    server =  process.env.NODE_ENV==='development'? DEFAULT_SERVER_DEV: DEFAULT_SERVER_PRO;
    console.log('meta server undefinido, loading default:',server); 
  }

  let appLogs = getMeta("logs");
  if(!appLogs){
    appLogs=process.env.NODE_ENV==='development';
  }

  const serverEnv={
    server:server, 
    logs:appLogs,
    env:appEnv
  }

  console.log('serverEnv',serverEnv); 
  return serverEnv; 
 }


 function getMeta(name){
  let result = document.querySelector(`meta[name='${name}']`)?.content
  return result;
}

 export {
    getServer
 }
